export default "__VITE_ASSET__8826a797__"